import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { backendApi } from "../../api/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { MdChevronRight } from "react-icons/md";
import {
  setSiteId,
  setUserData,
  setUserDetails,
  setUserId,
  setSiteHrmsFlag
} from "../../redux/reducers/loginSlice";
import { useDispatch } from "react-redux";
import Loading from "../../images/loading.gif";
import { Loader } from "react-feather";
import { FiXCircle } from "react-icons/fi";
export default function EmployerLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userName, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const [dataFlag, setDataFlag] = useState(false);
  // localStorage?.setItem("isLogin", 1); //! Comment later
  const [siteDetails, setSiteDetails] = useState([]);
  const [showCareers, setShowCareers] = useState(true);

  useEffect(() => {
    getSiteDetails();
  }, []);

  const goToCareers = () => {
    navigate(`/careers/${siteDetails[0].id}`);
  };

  const getSiteDetails = () => {
    const currentUrl = window.location.href;

    // Extract site ID from the URL
    const siteIdMatch = currentUrl.match(/\/(\d+)\/?$/);
    const siteId = siteIdMatch ? siteIdMatch[1] : "";

    // Extract web URL from the URL
    const webUrlMatch = currentUrl.match(/^(https?:\/\/[^\/]+)\/?/);
    const webUrl = webUrlMatch ? webUrlMatch[1] : "";
    var req = {
      functionName: "getSiteDetails",
      site_id: siteId ? siteId : "",
      web_url: webUrl ? webUrl : "",
    };
    backendApi(req).then((response) => {
      console.log("🚀 ~ backendApi ~ response:", response);
      if (response.success === "1") {
        setSiteDetails(response.dataSet);
        if (response.dataSet.length > 0) {
          setShowCareers(true);
          localStorage.setItem("logo", response.dataSet[0].company_logo);
        }
      } else {
        return false;
      }
    });
  };

  const Login = (e) => {
    // e.preventDefault();
    if (userName === "") {
      toast.warn("Please enter your Username", { containerId: "D" });
      return false;
    } else if (password === "") {
      toast.warn("Please enter your password", { containerId: "D" });
      return false;
    }
    setDataFlag(true);
    var req = {
      functionName: "login_auth",
      email_id: userName,
      password: password,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          console.log(response, "response_");

          dispatch(setUserDetails(response.userDetails));
          dispatch(setUserData(response.userData));
          dispatch(setSiteId(response.userDetails[0].site_id));
          dispatch(setUserId(response.userData[0].id));
          dispatch(setSiteHrmsFlag(response.siteDetails[0].is_hrms_connect))
          localStorage.setItem('logo', response.siteDetails[0].company_logo);
          localStorage.setItem("userId", response.userData[0].id);
          localStorage.setItem("siteId", response.userDetails[0].site_id);
          localStorage.setItem("role_id", response.userDetails[0].role_id);
          // localStorage.setItem("isLogin", 1);
          window.location.href = "/dashboard/dashboardMain";
        } else {
          toast.warn("Wrong username or password", { containerId: "D" });
          return false;
        }
      })
      .finally(() => setDataFlag(false));
  };

  const handleForgotPwd = () => {
    if (userName === "") {
      toast.warn("Please enter your Username", { containerId: "D" });
      return false;
    }
    setDataFlag(true);
    var req = {
      functionName: "resetPassword",
      email_id: userName,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          toast.success("Password sent to your Email Account", {
            containerId: "D",
          });
          setForgotPassword(false);
        } else {
          toast.warn("Something went wrong", { containerId: "D" });
          return false;
        }
      })
      .finally(() => setDataFlag(false));
  };

  return (
    <div className="bg-login">
      <ToastContainer
        enableMultiContainer
        containerId={"D"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="container h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-xl-10 position-relative">
            <FiXCircle className="popup_close" onClick={() => navigate('/')} />
            <div className="card rounded-3 text-black">
              <div className="row">
                <div className="col-lg-6">
                  <div className="card-body p-md-2 mx-md-4">
                    {siteDetails.length > 0 && (
                      <div className="text-center mb-0 recruitment_logo">
                        <img src={siteDetails[0].company_logo} width="250" />
                        {/* <span className="recruitment_text_logo">{siteDetails[0].company_logo}</span> */}
                      </div>
                    )}
                    {forgotPassword ? (
                      <form>
                        <div className="form-outline mb-2">
                          <label className="form-label" for="form2Example11">
                            Email-Id
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email-Id"
                            value={userName}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>
                        <div className="text-center pt-1 mb-2 pb-1 d-flex flex-column">
                          {dataFlag ? (
                            <button
                              className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3"
                              type="button"
                              onClick={handleForgotPwd}
                            >
                              <img
                                src={Loading}
                                alt="loaderImg"
                                width={20}
                                height={20}
                              ></img>
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3"
                              type="button"
                              onClick={handleForgotPwd}
                            >
                              Submit
                            </button>
                          )}
                        </div>
                        <div className="d-flex align-items-center justify-content-between pb-4">
                          <p className="mb-0 me-2 sign-in-form">
                            Don't have an account?
                          </p>
                          <a href="/signup" className="btn btn-outline-primary btn-sm create-new">
                            Create new
                          </a>
                        </div>
                      </form>
                    ) : (
                      <form>
                        <div className="form-outline mb-2">
                          <label className="form-label" for="form2Example11">
                            Email-Id
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            placeholder="Email-Id"
                            value={userName}
                            onChange={(e) => setUsername(e.target.value)}
                          />
                        </div>

                        <div
                          className="form-outline mb-2"
                          style={{ position: "relative", width: "100%" }}
                        >
                          <label className="form-label" for="form2Example22">
                            Password
                          </label>
                          <input
                            id="form2Example22"
                            className="form-control"
                            type={showPassword ? "text" : "password"}
                            placeholder="Password"
                            onChange={(e) => setPassword(e.target.value)}
                            onKeyDown={(event) => {
                              if (event.key === "Enter") {
                                Login(); // Call the Login method when the Enter key is pressed
                              }
                            }}
                          />
                          <span className="showPswd">
                            {showPassword && (
                              <FaEye onClick={() => setShowPassword(false)} />
                            )}
                            {!showPassword && (
                              <FaEyeSlash
                                onClick={() => setShowPassword(true)}
                              />
                            )}
                          </span>
                        </div>

                        <div className="text-center pt-1 mb-2 pb-1 d-flex flex-column">
                          {dataFlag ? (
                            <button
                              className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3"
                              type="button"
                            >
                              <img
                                src={Loading}
                                alt="loaderImg"
                                width={20}
                                height={20}
                              ></img>
                            </button>
                          ) : (
                            <button
                              className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3 mt-1"
                              type="button"
                              onClick={Login}
                            >
                              Log in
                            </button>
                          )}
                          <span
                            className="text-muted"
                            style={{ cursor: "pointer" }}
                            onClick={() => setForgotPassword(true)}
                          >
                            Forgot password?
                          </span>
                        </div>
                        <div className="d-flex align-items-center justify-content-between pb-4">
                          <p className="mb-0 me-2 sign-in-form">
                            Don't have an account?
                          </p>
                          <a href="/signup" className="btn btn-outline-primary btn-sm create-new">
                            Create new
                          </a>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="d-flex align-items-center gradient-custom-2">
                    <div className="text-white px-3 py-4 p-md-5 mx-md-4">
                      <h4 className="login-head">Revolutionize your hiring process</h4>
                      <p className="small mb-0">
                        Say goodbye to recruitment headaches. Our software
                        empowers you to create a seamless and enjoyable
                        experience for both candidates and hiring teams.
                      </p>
                      <br></br>
                      <p className="small mb-0">
                        Unlock the full potential of your HR team with our
                        recruitment software. From applicant tracking to
                        onboarding, we've got your entire talent journey
                        covered.
                      </p>
                      <br></br>
                      {/* <br></br>
                      <p className="small mb-0"></p> */}
                      {showCareers && siteDetails.length > 0 && (
                        <button
                          className="btn-careers btn-join mt-3"
                          onClick={() => goToCareers()}
                        >
                          Careers
                          <span className="float-right">
                            <MdChevronRight size={22} />
                          </span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
